import { Theme } from "@mui/material";
import { truncate } from "lodash";

import { ChannelTotalROIMap } from "@/pages/channel-roi/types";

import { formatTooltip } from "./formatTooltip";

// Define a consistent bar width to match Channel Effectiveness
const BAR_WIDTH = "20px";

export const getChartOption = (
  data: ChannelTotalROIMap,
  theme: Theme,
  showLength: boolean,
  showPeak: boolean
) => {
  return {
    grid: {
      left: 40,
      right: 50,
      top: 20,
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: theme.palette.echartTooltip.background,
      textStyle: {
        color: theme.palette.echartTooltip.textColor,
        fontSize: 14,
      },
      padding: [16, 24],
      extraCssText: "width: 200px; white-space: normal;",
      formatter: formatTooltip,
      axisPointer: {
        type: "shadow",
      },
    },
    xAxis: {
      data: Object.keys(data),
      axisLabel: {
        color: theme.palette.brandedTypography?.textColor,
        fontSize: 14,
        margin: 32,
        interval: 0,
        formatter: (value: string) => truncate(value, { length: 16 }),
      },
      axisTick: {
        alignWithLabel: true,
      },
      boundaryGap: true,
      splitLine: {
        show: true,
        alignWithLabel: true,
        lineStyle: {
          type: "dashed",
          color: theme.palette.ChartGuideLines.color,
        },
      },
    },
    yAxis: {
      minInterval: 1,
      axisLabel: {
        fontSize: 16,
        color: theme.palette.brandedTypography?.textColor,
      },
      nameLocation: "end",
      nameTextStyle: {
        fontSize: 18,
        fontWeight: "bold",
        color: theme.palette.brandedTypography?.textColor,
        padding: [0, 0, 10, 0],
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: "dashed",
          color: theme.palette.ChartGuideLines.color,
        },
      },
    },
    series: [
      showLength && {
        name: "Length",
        data: Object.values(data).map((channel) => channel.adstockDuration),
        type: "bar",
        color: theme.palette.adStockChart?.length,
        barWidth: BAR_WIDTH,
        itemStyle: {
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: {
          focus: "none",
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        z: 2,
      },
      showPeak && {
        name: "Peak",
        data: Object.values(data).map((channel) => channel.adstockPeak),
        type: "bar",
        color: theme.palette.adStockChart?.peak,
        barWidth: BAR_WIDTH,
        itemStyle: {
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: {
          focus: "none",
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        z: 2,
      },
    ],
  };
};
